(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  // This script is for the image optimization and should remain
  const firstSectionImage = document.querySelector('.main-content > .shopify-section img');
  if (firstSectionImage) {
    firstSectionImage.setAttribute('loading', 'eager');
    firstSectionImage.setAttribute('fetchpriority', 'high');
  }

  // --- Accordion Javascript ---
  class FooterAccordion {
    constructor(container) {
      this.container = container;
      this.triggers = this.container.querySelectorAll('.footer__accordion-trigger');
      this.mobileMediaQuery = window.matchMedia('(max-width: 749px)');
      this.handleResize = this.handleResize.bind(this);
      this.toggle = this.toggle.bind(this);
    }

    init() {
      this.mobileMediaQuery.addEventListener('change', this.handleResize);
      this.handleResize(this.mobileMediaQuery);
    }

    toggle(event) {
      const trigger = event.currentTarget;
      const parentBlock = trigger.closest('.footer__block');
      const wasOpen = parentBlock.classList.contains('is-open');
      
      parentBlock.classList.toggle('is-open', !wasOpen);
      trigger.setAttribute('aria-expanded', String(!wasOpen));
    }
    
    handleResize(e) {
      if (e.matches) {
        // Mobile view
        this.triggers.forEach(trigger => {
          trigger.addEventListener('click', this.toggle);
          const parentBlock = trigger.closest('.footer__block');
          const isOpen = parentBlock.classList.contains('is-open');
          trigger.setAttribute('aria-expanded', String(isOpen));
        });
      } else {
        // Desktop view
        this.triggers.forEach(trigger => {
          trigger.removeEventListener('click', this.toggle);
          trigger.closest('.footer__block').classList.remove('is-open');
        });
      }
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const footerElement = document.querySelector('[data-section-type="footer"]');
    if (footerElement) {
      new FooterAccordion(footerElement).init();
    }
  });


  } catch(e) { console.error(e); }
})();
})();
